export const ImageModule = {
  CAPTURE: 0,
  FOCUS: 1,
  ALIGN: 2,
  GUIDE: 3,
  DARK: 4,
  LIVE: 5,
};